import { render, staticRenderFns } from "./Trigger-segmentation.vue?vue&type=template&id=1b3a8d72&scoped=true&"
import script from "./Trigger-segmentation.vue?vue&type=script&lang=js&"
export * from "./Trigger-segmentation.vue?vue&type=script&lang=js&"
import style0 from "./Trigger-segmentation.vue?vue&type=style&index=0&id=1b3a8d72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a8d72",
  null
  
)

export default component.exports